module.exports = __webpack_public_path__ + "f54b6cf36db48bd7558a78a4c8ae74e3.svg";